import { Document, Page, Text, View, StyleSheet, pdf, Font, Image } from '@react-pdf/renderer';
import mobileImageDorado from '../images/logo_central-dorado-mobile.png'

const styles = StyleSheet.create({
    page: { padding: 40, fontSize: 11 },
    title: { fontSize: 22, marginBottom: 20, textAlign: 'center', fontWeight: 'bold' },
    subtitle: { fontSize: 14, marginBottom: 20, textAlign: 'center', color: '#555' },
    header: { marginBottom: 20 },
    row: { flexDirection: 'row', marginBottom: 6 },
    label: { width: 150, fontWeight: 'bold' },
    value: { flex: 1 },
    table: { marginTop: 10 },
    logo: {
        width: 150,           // ← tamaño fijo en puntos (recomendado)
        height: 'auto',       // mantiene proporción
        marginBottom: 10,
        alignSelf: 'center',  // centra la imagen horizontalmente
        // maxWidth: '50%',   // alternativa: máximo 50% del ancho de página
    },
    tableHeader: {
        flexDirection: 'row',
        backgroundColor: '#D2A120',
        color: 'white',
        fontWeight: 'bold',
        padding: 8
    },
    tableRow: {
        flexDirection: 'row',
        borderBottom: '1px solid #eee',
        paddingVertical: 6,
        paddingHorizontal: 8
    },
    cell: {
        flex: 1,
        textAlign: 'center'
    },
    footer: {
        marginTop: 30,
        textAlign: 'center',
        fontSize: 10,
        color: '#666'
    }
});

export const CotizadorPDF = ({ credito, capital, cuotas, tasas, user }) => (
    <Document>
        <Page size="A4" style={styles.page}>
            <Image style={styles.logo} src={mobileImageDorado} />
            <Text style={styles.title}>Simulador de créditos</Text>
            <View style={styles.header}>
                <View style={styles.row}>
                    <Text style={styles.label}>Línea de crédito:</Text>
                    <Text style={styles.value}>{credito}</Text>
                </View>

                {/*<View style={styles.row}>*/}
                {/*    <Text style={styles.label}>Tipo de cliente:</Text>*/}
                {/*    <Text style={styles.value}>Comercial / Pyme</Text>*/}
                {/*</View>*/}
                {/*<View style={styles.row}>*/}
                {/*    <Text style={styles.label}>Cliente:</Text>*/}
                {/*    <Text style={styles.value}>{user?.data?.nombre + ' ' + user.data.apellido || 'Cliente'}</Text>*/}
                {/*</View>*/}
                <View style={styles.row}>
                    <Text style={styles.label}>Fecha de generación:</Text>
                    <Text style={styles.value}>{new Date().toLocaleDateString('es-AR')}</Text>
                </View>
                <View style={styles.row}>
                    <Text style={styles.label}>Capital solicitado:</Text>
                    <Text style={styles.value}>{capital ? `$ ${capital}` : '-'}</Text>
                </View>
                <View style={styles.row}>
                    <Text style={styles.label}>Plazo:</Text>
                    <Text style={styles.value}>{cuotas} cuotas mensuales</Text>
                </View>
                <View style={styles.row}>
                    <Text style={styles.label}>Sistema de Amortización:</Text>
                    <Text style={styles.value}>Sistema Francés</Text>
                </View>
            </View>

            <View style={styles.table}>
                <View style={styles.tableHeader}>
                    <Text style={styles.cell}>Cuota</Text>
                    <Text style={styles.cell}>Total</Text>
                    <Text style={styles.cell}>Capital</Text>
                    <Text style={styles.cell}>Interés</Text>
                    {/*<Text style={styles.cell}>Cuota Pura</Text>*/}
                    <Text style={styles.cell}>Gastos</Text>
                    <Text style={styles.cell}>IVA</Text>
                </View>

                {tasas?.result?.datos?.map((row: any, i: number) => (
                    <View key={i} style={styles.tableRow}>
                        <Text style={styles.cell}>{row.nroCuota}</Text>
                        <Text style={styles.cell}>{formatCurrency(row.total)}</Text>
                        <Text style={styles.cell}>{formatCurrency(row.capital)}</Text>
                        <Text style={styles.cell}>{formatCurrency(row.interes)}</Text>
                        {/*<Text style={styles.cell}>{formatCurrency(row.cuotaPura)}</Text>*/}
                        <Text style={styles.cell}>{formatCurrency(row.gastos)}</Text>
                        <Text style={styles.cell}>{formatCurrency(row.iva)}</Text>
                    </View>
                ))}
            </View>

            {/*<Text style={styles.footer}>*/}
            {/*    Cotización válida por 48hs • Generada con Cotizador PYME*/}
            {/*</Text>*/}
        </Page>
    </Document>
);

// Reutilizas tu función formatCurrency que ya tienes
const formatCurrency = (value: any) => {
    if (value === null || value === undefined || isNaN(value)) return '$ 0,00';
    const number = Number(value).toFixed(2);
    const [integerPart, decimalPart] = number.split('.');
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `$ ${formattedInteger},${decimalPart}`;
};